export default "__VITE_ASSET__BVp72w8j__"